import { create } from 'zustand';
import { Category, Product } from '../types';

interface AppState {
  categories: Category[];
  products: Product[];
  selectedCategory: Category | null;
  selectedProduct: Product | null;
  isLoading: boolean;
  error: string | null;
  setCategories: (categories: Category[]) => void;
  setProducts: (products: Product[]) => void;
  setSelectedCategory: (category: Category | null) => void;
  setSelectedProduct: (product: Product | null) => void;
  setLoading: (isLoading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useStore = create<AppState>((set) => ({
  categories: [],
  products: [],
  selectedCategory: null,
  selectedProduct: null,
  isLoading: false,
  error: null,
  setCategories: (categories) => set({ categories }),
  setProducts: (products) => set({ products }),
  setSelectedCategory: (category) => set({ selectedCategory: category }),
  setSelectedProduct: (product) => set({ selectedProduct: product }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
})); 